/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_ScoreInputs */

const en_min_score = /** @type {(inputs: Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min score`)
};

const es_min_score = /** @type {(inputs: Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntaje min`)
};

/**
* | output |
* | --- |
* | "Min score" |
*
* @param {Min_ScoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const min_score = /** @type {((inputs?: Min_ScoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_ScoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_min_score(inputs)
	return es_min_score(inputs)
});